import * as React from "react";

interface Props {
  height?: number;
  width?: number;
}

const Dots = ({ height = 800, width = 800, ...props }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="-6 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>
      {"navigation / 13 - navigation, dots, more, vertical, option icon"}
    </title>
    <g
      id="Free-Icons"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-1051.000000, -750.000000)"
        fill="#000000"
        id="Group"
      >
        <g transform="translate(1041.000000, 746.000000)" id="Shape">
          <path d="M12,4 C10.8954305,4 10,4.8954305 10,6 C10,7.1045695 10.8954305,8 12,8 C13.1045695,8 14,7.1045695 14,6 C14,4.8954305 13.1045695,4 12,4 Z" />
          <path d="M12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 Z" />
          <path d="M12,16 C10.8954305,16 10,16.8954305 10,18 C10,19.1045695 10.8954305,20 12,20 C13.1045695,20 14,19.1045695 14,18 C14,16.8954305 13.1045695,16 12,16 Z" />
        </g>
      </g>
    </g>
  </svg>
);
export default Dots;
